import { render, staticRenderFns } from "./PerformanceInput.vue?vue&type=template&id=011a3a10&scoped=true&"
import script from "./PerformanceInput.vue?vue&type=script&lang=js&"
export * from "./PerformanceInput.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceInput.vue?vue&type=style&index=0&id=011a3a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011a3a10",
  null
  
)

export default component.exports